export const SITE_ID_QUERY_PARAM = 'siteId';
export const SITE_NAME_QUERY_PARAM = 'siteName';

const ENROLLING_FRAGMENT = 'f-trialenrollingstatus=Enrolling';

export type FindTrialSiteParams = {
  siteId?: string;
  siteName?: string;
};

const withEnrollingHash = (href: string): string => {
  if (href.includes('f-trialenrollingstatus=')) {
    return href;
  }
  return href.includes('#') ? `${href}&${ENROLLING_FRAGMENT}` : `${href}#${ENROLLING_FRAGMENT}`;
};

/** Find Trials link with enrolling facet hash only (site lock lives in Redux). */
export const withFindTrialsSiteParams = (href: string): string => {
  if (!href) {
    return href;
  }
  return withEnrollingHash(href);
};

/** Values the Find Trials page was opened with. Empty on the server and on a cold start. */
export const getFindTrialsSiteParams = (): FindTrialSiteParams => {
  if (typeof window === 'undefined') {
    return { siteId: '', siteName: '' };
  }

  const search = new URLSearchParams(window.location.search);
  return {
    siteId: (search.get(SITE_ID_QUERY_PARAM) ?? '').trim(),
    siteName: (search.get(SITE_NAME_QUERY_PARAM) ?? '').trim(),
  };
};

/** Chip X: drop site lock from the URL, keep path/hash/other query params. */
export const clearFindTrialsSiteParamsFromUrl = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  const url = new URL(window.location.href);
  url.searchParams.delete(SITE_ID_QUERY_PARAM);
  url.searchParams.delete(SITE_NAME_QUERY_PARAM);
  window.history.replaceState(null, '', `${url.pathname}${url.search}${url.hash}`);
};
